import { useMemo } from 'react';
import { format } from 'date-fns';
import { Typography } from '@components/Typography';
import { useTranslation } from '@hooks';
import { getFullName } from '@helpers/userName';
import { ConversationActivity } from '@constants/conversations';

const ConversationsEvent = ({ data, users, agents }) => {
    const { t } = useTranslation();

    const user = useMemo(() => users.find(user => user.id === data.userId), [users, data.userId]);
    const agent = useMemo(() => agents.find(agent => agent.id === data.agentId), [agents, data.agentId]);
    const ActivityText = {
        [ConversationActivity.Started]: 'InboxPage.conversationStarted',
        [ConversationActivity.Opened]: 'InboxPage.reopenedBy',
        [ConversationActivity.Closed]: 'InboxPage.resolvedBy',
        [ConversationActivity.Reassigned]: '',
    };

    return data.type !== ConversationActivity.Reassigned ? (
        <div style={{ position: 'relative', display: 'flex', justifyContent: 'center', marginTop: 8 }}>
            <Typography
                variant="caption"
                sx={{
                    color: 'rgba(0, 0, 0, 0.38)',
                    padding: '0 8px',
                    zIndex: 2,
                    backgroundColor: '#fff',
                    textAlign: 'center',
                }}
            >
                {t(ActivityText[data.type], {
                    date: format(new Date(data.createdAt), 'dd/MM • HH:mm'),
                    name: agent?.name || getFullName(user?.firstName, user?.lastName, '-'),
                })}
            </Typography>
            <div
                style={{
                    borderTop: '1px dashed rgba(0, 0, 0, 0.12)',
                    position: 'absolute',
                    left: 0,
                    right: 0,
                    top: '50%',
                }}
            />
        </div>
    ) : null;
};

export default ConversationsEvent;
